<nav>
  <!---------Start: Main Modules menu -->
  <dxp-page-header page-title="Cross Border Control" has-app-menu="true" has-action-items="false" has-search-box="false"
    back-icon="false" back-icon-aria-text="this link is for Back icon" help-icon="false"
    help-icon-aria-text="this link is for Help icon" data-theme="dxp-theme-b2b">

    <dxp-nav nav-type="deep-nav">
      <dxp-nav-menu *ngFor="let menuItem of this.menu" [linkTitle]="menuItem.name" button=false
        [navigationTitle]="menuItem.name" open-in-new-tab="false" [accessibilityText]="menuItem.ariaLabel"
        [menuRouteLink]="menuItem.path">
        <dxp-deep-nav-container>
          <dxp-deep-nav *ngIf="menuItem.subMenus != null">
            <dxp-deep-nav-item *ngFor="let subMenuItem of menuItem.subMenus" [linkTitle]="subMenuItem.name"
              [navigationTitle]="subMenuItem.name" [accessibilityText]="subMenuItem.ariaLabel"
              [menuRouteLink]="subMenuItem.path">
            </dxp-deep-nav-item>
          </dxp-deep-nav>
        </dxp-deep-nav-container>
      </dxp-nav-menu>
    </dxp-nav>
  </dxp-page-header>
</nav>